import '@/modules/card';
import Swiper from 'swiper';
import SwiperCore, { Pagination, Navigation, Scrollbar } from 'swiper/core';
import 'swiper/css';
import debounce from 'lodash/debounce';
SwiperCore.use([Pagination, Navigation, Scrollbar]);

export default class PopularArticlesCarousel {
    /**
        * Class constructor *
        * @arg {object} - `sliderElement` check for the
        * product carousel element.
    **/
    constructor (sliderElement) {
        if (!sliderElement) return;

        this.swiperInit = false;
        this.sliderElement = sliderElement;
        this.slides = this.sliderElement.querySelectorAll('.js-slides');
        this.sliderWrapper = this.sliderElement.querySelector('.js-swiper-wrapper');
        this.arrowNext = this.sliderElement.querySelector('.swiper-button-next');
        this.arrowPrev = this.sliderElement.querySelector('.swiper-button-prev');
        this.pagination = this.sliderElement.querySelector('.swiper-pagination');
        this.scrollbar = this.sliderElement.querySelector('.swiper-scrollbar');
        this.handleSwiperInit();

        const debouncedSwiperInit = debounce(() => {
            this.handleSwiperInit();
        }, 100);

        window.addEventListener('resize', () => {
            debouncedSwiperInit();
        });
    }

    handleSwiperInit() {
        if (window.innerWidth < 1024) {
            this.swiper = new Swiper(this.sliderElement, {
                slidesPerView: 1.4,
                spaceBetween: 20,
                threshold: 10,
                pagination: {
                    el: this.pagination
                },
                navigation: {
                    nextEl: this.arrowNext,
                    prevEl: this.arrowPrev
                },
                scrollbar: {
                    el: this.scrollbar,
                    draggable: true,
                    hide: false
                }
            });
            this.sliderElement.classList.add('swiper');
            this.sliderWrapper.classList.add('swiper-wrapper');
            this.slides.forEach(slide => {
                slide.classList.add('swiper-slide');
            });
            this.swiper.init();
            this.swiperInit = true
        } else {
            this.sliderElement.classList.remove('swiper');
            this.sliderWrapper.classList.remove('swiper-wrapper');
            this.slides.forEach(slide => {
                slide.classList.remove('swiper-slide');
            });
            if (this.swiperInit) {
                this.swiper.destroy(true, true);
                this.swiperInit = false
            }
        }
    }
}
